import styled from "styled-components";

const PostListWrapper = styled.div`
  margin: 15px 0px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 0.7rem;
`;

export default PostListWrapper;
